import { MessageCircle, Phone } from "lucide-react";
import { COMPANY, waLink } from "@/lib/site";
import { getProductNameFromPath, trackEvent } from "@/lib/analytics";
import { useLocation } from "react-router-dom";

export const SalesTeam = () => {
  const { pathname } = useLocation();
  const productName = getProductNameFromPath(pathname);
  const productContext = pathname === "/produk/baja-ringan-galvalum" ? "Baja Ringan & Galvalum" : pathname === "/produk/animax-acrylic-sheet" ? "Acrylic Sheet" : "produk PT. Animax Putra Lancar";

  return (
    <section id="tim-sales" data-testid="sales-team-section" className="py-24 lg:py-32 bg-white relative">
      <div className="max-w-7xl mx-auto px-5 sm:px-6">
        <div className="max-w-3xl mb-12">
          <div className="tag-uppercase text-animax-orange mb-4">Tim Sales Kami</div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium text-animax-black">
            Untuk Harga Terbaik, Hubungi Tim Kami Langsung
          </h2>
          <p className="mt-4 text-neutral-600 text-lg leading-relaxed">
            Harga bervariasi tergantung ketebalan, warna, jumlah pesanan, dan lokasi pengiriman.
            Chat WhatsApp atau telepon langsung — tim kami siap membantu Anda.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COMPANY.whatsapp.map((w, i) => (
            <div
              key={i}
              className="card-lift p-6 rounded-2xl bg-neutral-50 border border-neutral-200 hover:border-animax-orange transition-all"
              data-testid={`sales-contact-${w.name.toLowerCase()}`}
            >
              <div className="flex items-center justify-between mb-4">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-animax-yellow to-animax-orange flex items-center justify-center text-animax-black font-display font-semibold text-sm">
                  {w.name.slice(0, 2)}
                </div>
                <div className="tag-uppercase text-neutral-500">Tim Sales</div>
              </div>
              <div className="font-display text-lg font-medium text-animax-black">{w.name}</div>
              <div className="text-neutral-600 text-sm mt-1 mb-5">{w.number}</div>
              <div className="flex gap-2">
                <a
                  href={waLink(w.raw, `Halo ${w.name}, saya ingin bertanya harga ${productContext}`)}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`sales-wa-${w.name.toLowerCase()}`}
                  onClick={() =>
                    trackEvent("whatsapp_button_clicked", {
                      category: "contact",
                      label: w.name,
                      source: "sales_team",
                      sales_name: w.name,
                      product_name: productName,
                    })
                  }
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full bg-animax-black text-white text-xs font-medium hover:bg-animax-orange transition-all"
                >
                  <MessageCircle className="w-3.5 h-3.5" />
                  WhatsApp
                </a>
                <a
                  href={`tel:${w.tel}`}
                  data-testid={`sales-tel-${w.name.toLowerCase()}`}
                  onClick={() =>
                    trackEvent("phone_number_clicked", {
                      category: "contact",
                      label: w.name,
                      source: "sales_team",
                      sales_name: w.name,
                      product_name: productName,
                    })
                  }
                  className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-full border border-animax-black text-animax-black text-xs font-medium hover:bg-animax-yellow transition-all"
                >
                  <Phone className="w-3.5 h-3.5" />
                  Telepon
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
